import qs from 'query-string';
import { SystemLanguage } from 'hooks/business/system/useSystem';
import {
  storeHomeV2Client,
  resolve,
  storeHomeClient,
  ImResponse,
  doorClient,
  messDoorClient,
} from '.';

interface WaPrivatePool {
  tunnelAccountId: number;
  tunnelName: string;

  // 是否在这个客服组中已经被分配给，true是分配过
  isAllocation: boolean;
}

export enum AccountType {
  // 未知 = 'UNDEFINED',
  其他 = 'OTHER',
  汽车 = 'AUTO',
  美容 = 'BEAUTY',
  服饰 = 'APPAREL',
  教育 = 'EDU',
  娱乐 = 'ENTERTAIN',
  企划 = 'EVENT_PLAN',
  金融 = 'FINANCE',
  百货 = 'GROCERY',
  政府 = 'GOVT',
  酒店 = 'HOTEL',
  健康 = 'HEALTH',
  非营利机构 = 'NONPROFIT',
  专业服务 = 'PROF_SERVICES',
  零售 = 'RETAIL',
  旅行 = 'TRAVEL',
  餐饮 = 'RESTAURANT',
}
export enum AccountStatus {
  被禁用 = 0,
  授权失效 = 1,
  待添加系统用户 = 2,
  待分享额度 = 3,
  待设置webhook = 4,
  待添加手机号 = 5,
  已授权 = 6,
}

export enum MessageTemplateState {
  PENDING_REVIEW = 'PENDING_REVIEW',
  EXPIRED = 'EXPIRED',
  DECLINED = 'DECLINED',
  APPROVED = 'APPROVED',
}

export enum WaMsgTemplateTypeInConversation {
  GENERAL = 'GENERAL',
  STOCKOUT = 'STOCKOUT',
  SALES_RETURN = 'SALES_RETURN',
  BAD_REVIEW = 'BAD_REVIEW',
}

export const enableWa = () => {
  return resolve(storeHomeV2Client.get<ImResponse<boolean>>('/admin/is_belong_wa_whitelist'));
};

export const getWaPrivatePool = (assistantGroupId?: string) => {
  return resolve(
    storeHomeClient.get<ImResponse<WaPrivatePool[]>>('/store_groups/get_tunnel_account_info', {
      params: {
        assistantGroupId,
      },
    }),
  );
};

export interface GetWabaAccountListParams {
  keyword?: string;
  pageNum?: number;
  pageSize?: number;
  // 0 全部 1. 未分配客服组 2.异常
  type?: 0 | 1 | 2;
  ids?: number[];
}

export interface WabaAccountListRes {
  pageNum: number;
  pageSize: number;
  totalPages: number;
  totalAll: number;
  totalUndistributed: number;
  totalAbnormal: number;
  accounts: WhatsappBusinessApi.Account[];
}
export const getWabaAccountList = (
  params: GetWabaAccountListParams,
): Promise<WabaAccountListRes> => {
  return resolve(
    doorClient.get('/oversea-wa-biz-home/waba/list', {
      params,
      paramsSerializer: (params) => qs.stringify(params, { arrayFormat: 'none' }),
    }),
  );
};

export interface AggregationWabaListParams extends GetWabaAccountListParams {
  tunnelAccountIds?: (number | string)[];
}

export const aggregationWabaList = (params: AggregationWabaListParams) => {
  return resolve(
    doorClient.get<ImResponse<WabaAccountListRes>>('/aggregation/v1/waba/list', {
      params,
      paramsSerializer: (params) => qs.stringify(params, { arrayFormat: 'none' }),
    }),
  );
};

export const getWabaAccountCountInMsgTemplate = (): Promise<
  Array<{ wabaId: string; phone: string; count: number }>
> => {
  return resolve(doorClient.get('/oversea-wa-biz-home/msgTemplate/count'));
};

export const getWabaAccountCount = (): Promise<number> => {
  return resolve(doorClient.get('/oversea-wa-biz-home/waba/count'));
};

export const getWabaInfoById = (phoneId: string): Promise<WhatsappBusinessApi.Info> => {
  return resolve(
    doorClient.get('/oversea-wa-biz-home/waba/phone/detail', {
      params: {
        phoneId,
      },
    }),
  );
};
export const updateWabaInfo = (params: WhatsappBusinessApi.Info) => {
  return doorClient.put('/oversea-wa-biz-home/waba/phone/detail', params);
};

interface GetWhatsappMessageTemplateParams {
  wabaId?: string;
  phoneId?: string;
  showDetail?: boolean;
  type?: 'GENERAL' | 'STOCKOUT' | 'SALES_RETURN' | 'BAD_REVIEW';
  pageNum?: number;
  pageSize?: number;
  lang?: SystemLanguage;
  state?: WhatsappBusinessApi.MessageTemplateState;
}

export const getWhatsappMessageTemplate = (
  params?: GetWhatsappMessageTemplateParams,
): Promise<{
  data: WhatsappBusinessApi.MessageTemplate[];
  pageNum: number;
  pageSize: number;
  totalPages: number;
  totalRows: number;
}> => {
  return resolve(doorClient.get('/oversea-wa-biz-home/msgTemplate/list', { params }));
};
export const getWhatsappCostList = (params: {
  wabaId?: string;
  startTime?: number;
  endTime?: number;
  pageNum?: number;
  pageSize?: number;
}): Promise<{
  pageNum?: number;
  pageSize?: number;
  totalPages: number;
  totalRows: number;
  totalCost?: number;
  details: WhatsappBusinessApi.CostDetail[];
}> => {
  return resolve(doorClient.get('/oversea-wa-biz-home/costDetail/list', { params }));
};

export const getBalance = (): Promise<{ balance: number; free: number; freeze: number }> => {
  return resolve(doorClient.get('/oversea-wa-biz-home/capitalAccount'));
};

export const uploadFile = (
  file: File,
  sendToWa?: boolean,
): Promise<{
  // 储存在平台的链接
  url: string;
  // 本地链接
  localUrl: string;
  // 缩略图地址
  thumbUrl: string;
  // 视频长度
  videoDuration: number;
}> => {
  const formData = new FormData();
  formData.append('file', file);
  sendToWa && formData.append('sendToWa', 'true');
  return resolve(messDoorClient.post('/oversea-wa-biz-home/uploadFile', formData));
};

export const getWaMsgTemplateListInChat = (params: {
  conversationId: string;
  lang: string;
  type?: WhatsappBusinessApi.WaMsgTemplateTypeInConversation;
  pageNum?: number;
  pageSize?: number;
}): Promise<{
  msgTemplateList: {
    data: Omit<WhatsappBusinessApi.MessageTemplate, 'details'>[];
    pageNum: number;
    pageSize: number;
    totalPages: number;
    totalRows: number;
  };
  param: {
    orderId: string;
  };
}> => {
  return resolve(
    doorClient.get('/aggregation/v1/getWaMsgTemplateList', {
      params,
    }),
  );
};

export type TWaBa = {
  tunnelAccountId: string;
  wabaName: string;
  // conversationId > 0 标识存在会话.
  conversationId: string;
}[];
export const getWabaConversation = (params: {
  userId?: number;
  externalBuyerId: string;
}): Promise<{
  waBa: TWaBa;
}> => {
  return resolve(doorClient.get('/aggregation/v1/queryWaba', { params }));
};
